import { configureStore } from '@reduxjs/toolkit';
// import counterReducer from '../features/counter/counterSlice';
// import postsReducer from '../features/posts/postsSlice';
// import loafReducer from '../features/loaf';
import loanReducer from './routes/home2/loanSlice';

export default configureStore({
  reducer: {
    loan: loanReducer,
  },
});
